import React, { useState } from 'react';
import LineGrid from  "./ProductSearchGrid";

import api from '../api';

// Grid columns
const columns = [
  { field: 'idProd', headerName: 'Code', width: 150 },
  { field: 'desc_prod', headerName: 'Description', width: 648 },
  {field: 'qty', headerName: 'Qty', width: 100 }

];

const NewOrder =  () => {

    const inputRefs = {
        idCustomer: React.createRef(),  
        custOrder: React.createRef(),
        idProd: React.createRef(),
        qty: React.createRef()

    };

    // Decalare state fields
    const [formValues, setFormValues] = useState({
        idCustomer: '',
        custOrder: '',
        idProd: '',
        qty: 1  
    });    
    const [error, setError] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [productName, setProductName] = useState('');
    const [isProductValid, setIsProductValid] = useState(false);
    const [isTickEnabled, setIsTickEnabled] = useState(false);
    const [prodLines, setProdLines] = useState([]);  // Array to hold product lines
    const [nextRowId, setNextRowId] = useState(1); // To generate unique row IDs


    // Set initial focus on the customer ID input field
    React.useEffect(() => {
        inputRefs.idCustomer.current.focus();
    }, []);

    // UseEfect to enable/disable tick button based on product validity and qty
    React.useEffect(() => {
        const qtyNumber = Number(formValues.qty);
        const enabled = isProductValid && qtyNumber > 0;
        console.log("Tick Enabled:", enabled);
        setIsTickEnabled(enabled);
    }, [isProductValid, formValues.qty]);
    
    const handleInputChange = async (e) => {
        setError('');
        const {name, value} = e.target;
        setFormValues({
            ...formValues,
            [name]: value
        });

     };

    const handleBlur = async (e) => {
        const { name } = e.target;
        if (name === "idCustomer") {
          // Verify the customer number
          const idCustomer = inputRefs.idCustomer.current?.value;
          console.log("Customer ID:", idCustomer);

          try {
            console.log(window.APP_CONFIG?.API_URL);
            const apiURL = window.APP_CONFIG?.API_URL + "sales/verifyCustomer";
            const response = await api.get(apiURL, { params: { idCustomer } });
            console.log(response.status);
            if (response.status === 200) {
              console.log(response.data.name_cust);
              setCustomerName(response.data.name_cust);
            }
          } catch (error) {
            if (error.response) {
              if (error.response.status === 404) {
                console.log("Customer Not Found");
                setCustomerName("Invalid Customer");
                setError("Customer Not Found");
              }
            } else if (error.request) {
              setError("No response from server");
            } else {
              setError(error.message);
            }
          }
        }

        if (name === "idProd") {
          // Verify the product number
          const idProd = inputRefs.idProd.current?.value;
          console.log("Product ID:", idProd);

          try {
            console.log(window.APP_CONFIG?.API_URL);
            const apiURL = window.APP_CONFIG?.API_URL + "sales/verifyproduct";
            const response = await api.get(apiURL, { params: { idProd } });
            console.log(response.status);
            if (response.status === 200) {
              setProductName(response.data.desc_prod_full);
              setIsProductValid(true); // ✅ Mark product as valid
              console.log(response.data.desc_prod_full);
            } else {
              setIsProductValid(false); // ❌ Mark product as invalid
              
            }
          } catch (error) {
            setIsProductValid(false);
            if (error.response) {
              if (error.response.status === 404) {
                setProductName('');
                setError("Product Not Found");
              }
            } else if (error.request) {
              setError("No response from server");
            } else {
              setError(error.message);
            }
          }
        }        
    };



   const handleSubmitForm = async (e) => {
        e.preventDefault()
   }

    const handleVerifyProduct = async () => {
      const idProd = inputRefs.idProd.current?.value?.trim();
      const qtyStr = inputRefs.qty.current?.value ;
      const qty = Number(qtyStr);

      if (!idProd) {
        setError("Please enter a Product ID.");
        return;
      }
      if (isNaN(qty) || qty <= 0) {
        setError("Please enter a valid quantity greater than zero.");
        return;
      }

      const newLine = { id: nextRowId, idProd: idProd, desc_prod: productName, qty: qty };
      setProdLines((prevLines) => [...prevLines, newLine]);
      setNextRowId((prevId) => prevId + 1);
      setIsProductValid(false);
      setFormValues((prevValues) => ({ ...prevValues, idProd: '', qty: 1 }));
      setProductName('');
      inputRefs.idProd.current.focus();
      

      console.log("Verifying Product ID:", idProd, "Qty:", qtyStr);
    }


    const handleProdKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault(); // Prevent form submission
        handleVerifyProduct();
      }
    };

    return (
      <div>
      <div className="form-container">
        <form className="" onSubmit={handleSubmitForm}>
          <h1>{sessionStorage.nameSupp}</h1>

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label>
              <span>Customer ID:</span>
              <input
                type="number"
                name="idCustomer"
                ref={inputRefs.idCustomer}
                value={formValues.idCustomer}
                onChange={handleInputChange}
                onBlur={handleBlur}
                style={{ width: "80px" }}
              />
            </label>
            <label style={{ marginTop: "0px"}}>{customerName}</label>  
          </div>
          
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label>
              <span>Cust Order #:</span>
              <input
                type="text"
                name="custOrder"
                ref={inputRefs.custOrder}
                value={formValues.custOrder}
                onChange={handleInputChange}
                style={{ width: "150px" }}
              />
            </label>
          </div>
           
          <div style={{ height: "3px", backgroundColor: "#000000ff", margin: "10px 0" }}></div>

 <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  <label>
    <span>Product #:</span>
    <input
      type="text"
      name="idProd"
      ref={inputRefs.idProd}
      value={formValues.idProd}
      onChange={handleInputChange}
      onBlur={handleBlur}
      onKeyDown={handleProdKeyDown}
      placeholder="Product ID"
      style={{ width: "175px" }}
    />
  </label>

  <label>
    <span>Qty:</span>
    <input
      type="number"
      name="qty"
      ref={inputRefs.qty}
      value={formValues.qty}
      onChange={handleInputChange}
      onKeyDown={handleProdKeyDown}
      placeholder="Qty"
      style={{ width: "80px" }}
    />
  </label>

  {/* ✅ Tick Button with spacing */}
  <button
    type="button"
    onClick={handleVerifyProduct}
    disabled={!isTickEnabled}
    style={{
      backgroundColor: isTickEnabled ? "#4CAF50" : "#A9A9A9",
      color: "white",
      border: "none",
      padding: "6px 10px",
      borderRadius: "4px",
      cursor: isTickEnabled ? "pointer" : "not-allowed",
      fontSize: "16px",
      marginLeft: "5px"
    }}
    title="Verify Product"
  >
    ✔
  </button>
</div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label><span></span></label>
            <label><strong>{productName}</strong></label>
          </div> 
          <div>
          <LineGrid columns={columns} rows={prodLines} />
          </div>
        </form>
        </div>
        {error && <div className="error-message">{error}</div>} 
      </div>
    );

}

export default NewOrder;